/* eslint-disable no-unused-vars */
import styled from '@emotion/styled';
import { Button, Space } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import slide1 from '../../assets/images/im1.jpg';
import { ROUTES } from '../../routes';
import { ORANGE, PRIMARY, SECONDARY, YELLOW } from '../../shared/colors';
import { RegistrationForm } from './components/registrationForm';

const RegistrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${SECONDARY};

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 11px;
  }

  .infos {
    display: none;
  }

  .forms {
    background-color: white;
    width: 300px;
    padding: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

    > h1 {
      font-family: Montserrat;
      text-align: center;
      color: ${PRIMARY};
    }
  }

  .conditions {
    font-size: 12px;
    color: #777;
    text-align: center;
    margin: 0;
  }

  @media (min-width: 768px) {
    > div {
      display: flex;
    }

    .infos {
      display: block;
      width: 450px;
      background-image: url(${slide1});
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      margin-top: 20px;
      margin-bottom: 20px;

      > div {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.7);

        .text {
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: center;
          padding: 20px;
          padding-top: 0;

          h2 {
            color: white;
            font-family: Montserrat;
          }

          > h1 {
            color: white;
            font-family: Montserrat;
            font-size: 35px;
            margin-bottom: 5px;
          }

          > p {
            color: white;
            font-size: 18px;
          }
        }
      }
    }

    .forms {
      width: 450px;
    }
  }
`;

export const RegistrationPage = () => {
  const router = useHistory();

  return (
    <RegistrationContainer>
      <div>
        <div className='infos'>
          <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <span
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </span>
            </div>

            <div className='text'>
              <h2>Bienvenu sur</h2>
              <h1>MoranjEtrade</h1>
              <p> ...</p>

              <Button
                className='butt-outline'
                type='primary'
                size='large'
                style={{
                  width: '80%',
                  marginBottom: 20,
                  borderRadius: 50,
                  fontWeight: 'bold',
                }}
                onClick={() => router.push(ROUTES.SIGNIN)}
              >
                Se connecter
              </Button>
            </div>
          </div>
        </div>
        <div className='forms'>
          <h1>Créer un compte</h1>
          <RegistrationForm />
          <Space
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              textAlign: 'center',
            }}
          >
            <p>Avez vous déjà un compte ?</p>
            <Link to={ROUTES.SIGNIN} style={{ textDecoration: 'underline' }}>
              <p>Connectez vous</p>
            </Link>
          </Space>
          <p className='conditions'>
            En cliquant sur 'Créer mon compte', j'accepte les{' '}
            <a href='.'>Conditions d'Utilisations</a> de <b>MoranjEtrade</b> et
            je comprends que les informations de mon compte seront utilisées
            conformément à la <a href='.'>Politique de confidentialité</a> de
            MoranjEtrade
          </p>
        </div>
      </div>
    </RegistrationContainer>
  );
};
